import {AxiosResponse} from "axios";
import {$api} from "../api/api.ts";
import {getToken} from "../../utils/Utils.ts";
import {
    ICampaignResponseData, ICampaignHistory, ICampaignUpdateParams,
    ICreateCampaignParamsData,
    ICurrentCampaignResponseData, ICampaignHistoryParams, ICampaignStats
} from "../models/CampaignResponse.ts";
import qs from "qs";


export const CampaignService = {
    fetchCampaigns(id:string): Promise<AxiosResponse<ICampaignResponseData[]>> {
        return $api.get(`/engagement_campaigns/${id}`, {
            headers: {
                Authorization: `Bearer tg-${getToken()}`
            }
        })
    },
    fetchCampaignHistory(id:string, params?:ICampaignHistoryParams): Promise<AxiosResponse<ICampaignHistory[]>> {
        return $api.get(`/engagement_campaigns/history/${id}`, {
            params,
            paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
            headers: {
                Authorization: `Bearer tg-${getToken()}`
            }
        })
    },
    fetchCampaignStats(id:string, params?:ICampaignHistoryParams): Promise<AxiosResponse<ICampaignStats[]>> {
        return $api.get(`/engagement_campaigns/stats/${id}`, {
            params,
            paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
            headers: {
                Authorization: `Bearer tg-${getToken()}`
            }
        })
    },
    createCampaign(data:ICreateCampaignParamsData): Promise<AxiosResponse<ICampaignResponseData>> {
        return $api.post('/engagement_campaigns', data, {
            headers: {
                Authorization: `Bearer tg-${getToken()}`
            }
        })
    },
    getCampaignByCampaignId(campaignId:string): Promise<AxiosResponse<ICurrentCampaignResponseData>> {
        return $api.get(`/engagement_campaign/${campaignId}`, {
            headers: {
                Authorization: `Bearer tg-${getToken()}`
            }
        })
    },
    updateCampaign(campaignId:string, data:ICampaignUpdateParams): Promise<AxiosResponse<ICurrentCampaignResponseData>> {
        return $api.patch(`/engagement_campaign/${campaignId}`, data, {
            headers: {
                Authorization: `Bearer tg-${getToken()}`
            }
        })
    },
}
